export default "__VITE_ASSET__Q79PGRl7__"